import { CONFIG } from 'constants/index';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { AppService } from 'services';
import { mergeObject } from 'utils/function';
import { replaceVarsInTranslation } from 'utils/translation';

interface DynamicFormDescriptions {
  commonText?: any;
  selectBox?: any;
  generalDialog?: any;
  loadingMessage?: string;
  commonStatus?: any;
  baseComponent?: any;
  noDevice: any;
}

export const useDynamicFormDescs = () => {
  const { t } = useTranslation(['common','selectBox','commonStatus','device','currentDevice','myDeviceDetail','myIssueDeviceDetail',
  'deliveryCard','contactCard','dynamicForm','checkEmail','attachment','userInfo','approvalForm','deviceDetailsCard','checkSerialNumber']);

  const [loading, setLoading] = useState(false);
  const [descriptions, setDescriptions] = useState<DynamicFormDescriptions>({ noDevice: {} });

  const { generalConfig } = useSelector((state: RootState) => state.configReducer) as any;
  const { verbiageConfig } = generalConfig;

  const replacedDescriptions = useMemo(() => {
    const variables = {
      select_text: t('dynamicForm:selectDeviceComponent.select'),
      back_button_label: t('dynamicForm:backButtonLabel'),
      next_button_label: t('checkSerialNumber:nextButtonLabel'),
      submit_button_label: t('dynamicForm:submitButtonLabel'),
    };
    const noDeviceDescriptions = {
      noDevice: t('dynamicForm:selectDeviceComponent.noDeviceDesc'),
      selected: t('dynamicForm:selectDeviceComponent.cancelEmptyDataDialogContent'),
      empty: t('dynamicForm:selectDeviceComponent.dataFalse.empty'),
    };
    const mergedDescriptions = mergeObject({ noDevice: noDeviceDescriptions }, descriptions);
    return replaceVarsInTranslation(mergedDescriptions, variables);
  }, [descriptions, t]);

  useEffect(() => {
    (async () => {
      if (!verbiageConfig) return;

      setLoading(true);

      try {
        const res = await AppService.getValueConfigAzure(
          CONFIG.DYNAMIC_FORM_DESCRIPTIONS.KEY,
          CONFIG.DYNAMIC_FORM_DESCRIPTIONS.LABEL,
        );
        const newDescriptions = res || {};
        const mergedDescriptions = mergeObject(descriptions, newDescriptions);
        setDescriptions(mergedDescriptions);
      } catch (error) {
        console.error(error);
      }

      setLoading(false);
    })();
  }, [verbiageConfig]);

  return { descriptions: replacedDescriptions, loading };
};
